import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import { FormattedNumber } from "react-intl";

import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle
} from "material-ui-next/Dialog";

import { fn } from "util";
import {
  Loadable,
  StyledButton,
  PdfDownload,
  TextField
} from "components/support";

class LabelModal extends Component {
  pdfDownload = () => {
    const {
      printPdf,
      product,
      onPrintChanged,
      setLoading,
      printAmount
    } = this.props;
    const products = [];

    for (let i = 0; i < printAmount; i++) {
      products.push({ name: product.name, sell_value: product.sell_value });
    }

    return (
      <PdfDownload
        print={printPdf[product.uuid]}
        onPrintFinished={() => onPrintChanged(product.uuid, false)}
        setLoading={value => setLoading(value)}
      >
        <Row className="mv-sm mh-md">
          {products.map((p, i) => {
            return (
              <Col
                xs={2}
                key={`${i}-${p.name}`}
                style={{ marginBottom: 4, textAlign: "center" }}
              >
                <Row center="xs">
                  <Col xs>
                    <span style={{ wordBreak: "break-all" }}>{p.name}</span>
                  </Col>
                </Row>
                <Row center="xs">
                  <Col xs>
                    <FormattedNumber
                      value={fn.centsToReal(p.sell_value)}
                      format="BRL"
                    />
                  </Col>
                </Row>
              </Col>
            );
          })}
        </Row>
      </PdfDownload>
    );
  };

  onBackButton = product_uuid => {
    const { onClose, resetPrintAmount } = this.props;

    resetPrintAmount();
    onClose(product_uuid);
  };

  render() {
    const {
      visible,
      loading,
      product,
      onClose,
      onPrintChanged,
      printAmount,
      setPrintAmount
    } = this.props;

    return (
      <Dialog
        open={visible}
        onClose={() => onClose(product.uuid)}
        style={{ textAlign: "center" }}
      >
        <Loadable loading={loading}>
          <DialogTitle>
            Informe a quantidade de etiquetas e faça o download
          </DialogTitle>

          <DialogContent>
            <TextField
              fullWidth
              value={printAmount}
              label="Quantidade de etiquetas"
              onChange={(_, value) =>
                setPrintAmount(parseInt(value.replace(/\D/g, ""), 10) || 0)
              }
            />

            {this.pdfDownload()}
          </DialogContent>

          <DialogActions>
            <StyledButton
              flat
              label="Voltar"
              onClick={() => this.onBackButton(product.uuid)}
            />

            <StyledButton
              disabled={!!!printAmount}
              primary
              label="Baixar"
              onClick={() => onPrintChanged(product.uuid, true)}
            />
          </DialogActions>
        </Loadable>
      </Dialog>
    );
  }
}

export default LabelModal;



// WEBPACK FOOTER //
// ./src/components/app/registration/product/list/data-table/label-modal/index.js